enum Names {
  NODE_ENV = 'NODE_ENV',
  TURNSTILE_SITE_KEY = 'TURNSTILE_SITE_KEY',
}

const PATH = '/env';

export { Names, PATH };
